import { render, staticRenderFns } from "./SalonsOfCars.vue?vue&type=template&id=dbd5b8f4"
import script from "./SalonsOfCars.vue?vue&type=script&lang=js"
export * from "./SalonsOfCars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports